//New ManagerTeamLeves
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import ManagerNavbar from "../Layout/ManagerNavbar";
import API_BASE_URL from "../config";

export default function ManagerTeamLeaves() {
    const [dashboardData, setDashboardData] = useState({ leaves: [] }); // will hold ALL leaves
    const [filteredLeaves, setFilteredLeaves] = useState([]);
    const [showRejectPopup, setShowRejectPopup] = useState(false);
    const [selectedLeaveId, setSelectedLeaveId] = useState(null);
    const [rejectReason, setRejectReason] = useState("");
    const [filters, setFilters] = useState({
        search: "",
        leaveType: "",
        status: "",
        startDate: "",         // initialize date keys
        endDate: "",
        dateRangePreset: "thisMonth", // start UI showing current month by default
    });
    const [sortConfig, setSortConfig] = useState({ key: "", direction: "asc" });
    const [leaveTypes, setLeaveTypes] = useState([]);
    const [actionType, setActionType] = useState("");
    const [forwardTo, setForwardTo] = useState("");
    const navigate = useNavigate();

    const [nextManager, setNextManager] = useState([]); // single manager
    const [admins, setAdmins] = useState([]);             // list of admins
    const [financialYear, setFinancialYear] = useState("");


    useEffect(() => {
        const token = localStorage.getItem("token");

        fetch(`${API_BASE_URL}/api/company-info`, {
            headers: { Authorization: "Bearer " + token },
        })
            .then(res => res.json())
            .then(data => {


                // API returns array → take first record
                const company = Array.isArray(data) ? data[0] : data;

                if (!company?.financialYear) {
                    console.warn("No financialYear found");
                    return;
                }

                setFinancialYear(company.financialYear);
            })

            .catch(err => console.error("Error fetching company info:", err));
    }, []);


    useEffect(() => {
        const token = localStorage.getItem("token");
        if (!token) return;

        fetch(`${API_BASE_URL}/api/leave-types/all`, {
            headers: { Authorization: "Bearer " + token },
        })
            .then((res) => {
                if (!res.ok) throw new Error("Failed to fetch leave types");
                return res.json();
            })
            .then((data) => {
                // ✅ assuming backend returns something like ["SICK", "CASUAL", "EARNED"]
                setLeaveTypes(data);
            })
            .catch((err) => console.error("❌ Error fetching leave types:", err));
    }, []);


    useEffect(() => {
        const token = localStorage.getItem("token");
        const userId = localStorage.getItem("employeeId");
        if (!token || !userId) return;

        // 🔹 Fetch reporters (managers) for logged-in manager
        fetch(`${API_BASE_URL}/api/manageteam/employee/${userId}/reporters`, {
            headers: { Authorization: "Bearer " + token },
        })
            .then(res => res.ok ? res.json() : [])
            .then(data => {
                // data = [{ reporterId, reporterName }]
                setNextManager(Array.isArray(data) ? data : []);
            })
            .catch(() => setNextManager([]));

        // 🔹 Fetch admins
        fetch(`${API_BASE_URL}/api/users/admins`, {
            headers: { Authorization: "Bearer " + token },
        })
            .then(res => res.json())
            .then(data => setAdmins(data || []))
            .catch(() => setAdmins([]));

    }, []);


    const normalizeLeaveType = (str = "") =>
        str
            .toLowerCase()
            .replace(/\s+/g, "")
            .replace(/[()]/g, "");


    const normalizeName = (name = "") =>
        name.trim().toLowerCase().replace(/\s+/g, " ");


    const getForwardOptions = () => {
        const map = new Map(); // key = normalized name

        // 1️⃣ Add Managers first (highest priority)
        nextManager.forEach((mgr) => {
            const key = normalizeName(mgr.reporterName);

            map.set(key, {
                value: mgr.reporterName,
                label: `${mgr.reporterName} (Manager)`
            });
        });

        // 2️⃣ Add Admins only if NOT already added as Manager
        admins.forEach((admin) => {
            const key = normalizeName(admin.name);

            if (!map.has(key)) {
                map.set(key, {
                    value: admin.name,
                    label: `${admin.name} (Admin)`
                });
            }
        });

        return Array.from(map.values());
    };






    // 🔐 Authentication check
    useEffect(() => {
        const token = localStorage.getItem("token"); // or localStorage
        if (!token) {
            toast.error("You must be logged in to access this page.");
            navigate("/");
        }
    }, [navigate]);

    // // ✅ Fetch team leaves (store ALL leaves)
    // useEffect(() => {
    //     const token = localStorage.getItem("token");
    //     if (!token) return;

    //     fetch(`${API_BASE_URL}/api/leaves/team-leaves`, {
    //         headers: {
    //             Authorization: "Bearer " + token,
    //             "Content-Type": "application/json",
    //         },
    //     })
    //         .then((res) => {
    //             if (!res.ok) throw new Error("Failed to fetch team leaves");
    //             return res.json();
    //         })
    //         .then((data) => {
    //             const leaves = Array.isArray(data) ? data : [];
    //             // store all leaves in dashboardData
    //             setDashboardData({ leaves });

    //             // set initial filtered view to current month (so UI still shows current month by default)
    //             const now = new Date();
    //             const currentMonthLeaves = leaves.filter((l) => {
    //                 const start = new Date(l.startDate);
    //                 return start.getMonth() === now.getMonth() && start.getFullYear() === now.getFullYear();
    //             });
    //             setFilteredLeaves(currentMonthLeaves);
    //         })
    //         .catch((err) => console.error("❌ Error loading team leaves:", err));
    // }, []);


    const fetchTeamAvailLeaves = async () => {
        const token = localStorage.getItem("token");
        if (!token || !financialYear) return; // ⛔ wait until FY is ready

        try {
            const res = await fetch(
                `${API_BASE_URL}/api/leave-transactions/team-avail?financialYear=${financialYear}`,
                {
                    headers: {
                        Authorization: "Bearer " + token,
                        "Content-Type": "application/json",
                    },
                }
            );

            if (!res.ok) throw new Error("Failed to fetch team leaves");

            const data = await res.json();
            const leaves = Array.isArray(data) ? data : [];

            // 🔁 map backend → UI contract
            const mappedLeaves = leaves.map(l => ({
                ...l,
                status: l.leaveStatus,
            }));

            setDashboardData({ leaves: mappedLeaves });

            // 📅 default view → current month
            const now = new Date();
            const currentMonthLeaves = mappedLeaves.filter(l => {
                const start = new Date(l.startDate);
                return (
                    start.getMonth() === now.getMonth() &&
                    start.getFullYear() === now.getFullYear()
                );
            });

            setFilteredLeaves(currentMonthLeaves);

        } catch (err) {
            console.error("❌ Error loading team leaves:", err);
        }
    };


    useEffect(() => {
        fetchTeamAvailLeaves();
    }, [financialYear]);




    // ✅ Format date
    const formatDate = (dateStr) =>
        new Date(dateStr).toLocaleDateString("en-GB", {
            day: "2-digit",
            month: "short",
            year: "numeric",
        });

    // ✅ Handle Approve / Forward
   const handleLeaveStatus = async (id, status) => {
  const token = localStorage.getItem("token");

  try {
    // ✅ Only APPROVE supported here
    if (status !== "APPROVED") {
      toast.error("This action is not supported here.");
      return;
    }

    const res = await fetch(
      `${API_BASE_URL}/api/leave-transactions/approve/${id}`,
      {
        method: "PUT",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    if (!res.ok) {
      const msg = await res.text();
      throw new Error(msg);
    }

    toast.success("Leave approved successfully");

    
   fetchTeamAvailLeaves();

  } catch (err) {
    console.error(err);
    toast.error(err.message || "Failed to approve leave");
  }
};


    const getUpcomingLeaves = () => {
        const today = new Date();
        const nextWeek = new Date();
        nextWeek.setDate(today.getDate() + 7);

        // Use dashboardData.leaves so it’s unaffected by filters
        return (dashboardData.leaves || []).filter((l) => {
            const start = new Date(l.startDate);
            return l.status === "APPROVED" && start >= today && start <= nextWeek;
        });
    };



    // ✅ Reject flow
    const handleRejectClick = (leaveId) => {
        setSelectedLeaveId(leaveId);
        setRejectReason("");
        setActionType("REJECTED");
        setShowRejectPopup(true);
    };

    const handleConfirmAction = async () => {
        if (!rejectReason.trim()) {
            toast.error("Please provide a reason.");
            return;
        }

        if (actionType === "FORWARDED" && !forwardTo) {
            toast.error("Please select whom to forward to.");
            return;
        }

        const token = localStorage.getItem("token");

        const apiUrl =
            actionType === "REJECTED"
                ? `${API_BASE_URL}/api/leave-transactions/reject/${selectedLeaveId}`
                : `${API_BASE_URL}/api/leave-transactions/forward/${selectedLeaveId}`;

        const payload =
            actionType === "REJECTED"
                ? { actionReason: rejectReason }
                : {
                    actionReason: rejectReason,
                    forwardTo: forwardTo,
                };

        try {
            const res = await fetch(apiUrl, {
                method: "PUT",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: "Bearer " + token,
                },
                body: JSON.stringify(payload),
            });

            if (!res.ok) throw new Error("Action failed");

            toast.success(
                actionType === "REJECTED"
                    ? "Leave rejected successfully!"
                    : `Leave forwarded to ${forwardTo}!`
            );

            setShowRejectPopup(false);
            setRejectReason("");
            setForwardTo("");
            setSelectedLeaveId(null);

            // 🔄 refresh list
            fetchTeamAvailLeaves();

        } catch (err) {
            console.error(err);
            toast.error("Failed to process leave action");
        }
    };








    // ✅ Handle filters
    useEffect(() => {
        // Work from the FULL dataset (dashboardData.leaves) — not from previously filtered items
        let filtered = [...(dashboardData.leaves || [])];
        const today = new Date();

        // 🔍 Search
        if (filters.search) {
            filtered = filtered.filter((l) =>
                l.user?.name?.toLowerCase().includes(filters.search.toLowerCase())
            );
        }

        // 🏷️ Leave Type
        if (filters.leaveType) {
            filtered = filtered.filter(
                (l) =>
                    normalizeLeaveType(l.leaveType) ===
                    normalizeLeaveType(filters.leaveType)
            );
        }


        // 📊 Status
        if (filters.status) filtered = filtered.filter((l) => l.status === filters.status);

        // 📅 Date presets (only if no manual date range is applied)
        if (!filters.startDate && !filters.endDate) {
            if (filters.dateRangePreset === "thisMonth") {
                filtered = filtered.filter((l) => {
                    const d = new Date(l.startDate);
                    return d.getMonth() === today.getMonth() && d.getFullYear() === today.getFullYear();
                });
            } else if (filters.dateRangePreset === "lastMonth") {
                const lastMonth = new Date(today.getFullYear(), today.getMonth() - 1, 1);
                filtered = filtered.filter((l) => {
                    const d = new Date(l.startDate);
                    return d.getMonth() === lastMonth.getMonth() && d.getFullYear() === lastMonth.getFullYear();
                });
            }
        }

        // ✅ Main Date Range (overlap rule) — include leaves that overlap the range
        // This ensures leaves that start before filterStart but end inside (or after) are included, etc.
        if (filters.startDate || filters.endDate) {
            const filterStart = filters.startDate ? new Date(filters.startDate) : new Date(-8640000000000000);
            const filterEnd = filters.endDate ? new Date(filters.endDate) : new Date(8640000000000000);

            // normalize to full day
            filterStart.setHours(0, 0, 0, 0);
            filterEnd.setHours(23, 59, 59, 999);

            filtered = filtered.filter((l) => {
                const leaveStart = new Date(l.startDate);
                const leaveEnd = new Date(l.endDate || l.startDate);
                leaveStart.setHours(0, 0, 0, 0);
                leaveEnd.setHours(23, 59, 59, 999);

                // overlap condition: leaveStart <= filterEnd && leaveEnd >= filterStart
                return leaveStart <= filterEnd && leaveEnd >= filterStart;
            });
        }

        // Apply current in-memory sort (if any)
        if (sortConfig.key) {
            const key = sortConfig.key;
            const dir = sortConfig.direction;
            filtered.sort((a, b) => {
                if (key === "startDate") {
                    const aDate = new Date(a.startDate);
                    const bDate = new Date(b.startDate);
                    return dir === "asc" ? aDate - bDate : bDate - aDate;
                } else {
                    const aVal = (a[key] || "").toString().toLowerCase();
                    const bVal = (b[key] || "").toString().toLowerCase();
                    return dir === "asc" ? aVal.localeCompare(bVal) : bVal.localeCompare(aVal);
                }
            });
        }

        setFilteredLeaves(filtered);
    }, [filters, dashboardData, sortConfig]);

    // ✅ Sorting
    const handleSort = (key) => {
        let direction = "asc";
        if (sortConfig.key === key && sortConfig.direction === "asc") direction = "desc";
        setSortConfig({ key, direction });
        // no need to explicitly sort here; filter effect will re-run because sortConfig changed
    };

    const truncate = (text, max = 30) =>
        text && text.length > max ? text.substring(0, max) + "..." : text;


    return (
        <>
            <div className="fixed-top">
                <ManagerNavbar />
            </div>
            <div className="container-fluid" style={{ paddingTop: "120px" }}>
                <h2 className="text-dark mb-4 text-start">Team Leaves</h2>

                {/* ✅ Filters */}
                <div className="card p-3 mb-4 shadow-sm">
                    <div className="row g-2 align-items-center">
                        <div className="col-md-2">
                            <input
                                type="text"
                                className="form-control"
                                placeholder="Search by Employee Name"
                                value={filters.search}
                                onChange={(e) => setFilters({ ...filters, search: e.target.value })}
                            />
                        </div>

                        <div className="col-md-2">
                            <select
                                className="form-select"
                                value={filters.leaveType}
                                onChange={(e) => setFilters({ ...filters, leaveType: e.target.value })}
                            >
                                <option value="">All Leave Types</option>
                                {leaveTypes.map((type) => (
                                    <option key={type.id} value={type.name}>
                                        {type.name.charAt(0).toUpperCase() + type.name.slice(1).toLowerCase()}
                                    </option>
                                ))}
                            </select>
                        </div>



                        <div className="col-md-2">
                            <select
                                className="form-select"
                                value={filters.status}
                                onChange={(e) => setFilters({ ...filters, status: e.target.value })}
                            >
                                <option value="">All Status</option>
                                <option value="PENDING">Pending</option>
                                <option value="APPROVED">Approved</option>
                                <option value="REJECTED">Rejected</option>
                                <option value="FORWARDED">Forwarded</option>
                            </select>
                        </div>

                        {/* ✅ This Month / Last Month Quick Filter */}
                        <div className="col-md-2">
                            <select
                                className="form-select"
                                value={filters.dateRangePreset}
                                onChange={(e) =>
                                    setFilters({
                                        ...filters,
                                        dateRangePreset: e.target.value,
                                        startDate: "",
                                        endDate: "",
                                    })
                                }
                            >
                                <option value="">All Dates</option>
                                <option value="thisMonth">This Month</option>
                                <option value="lastMonth">Last Month</option>
                            </select>
                        </div>

                        {/* ✅ Manual Date Range */}
                        <div className="col-md-3 d-flex gap-2">
                            <input
                                type="date"
                                className="form-control"
                                value={filters.startDate}
                                onChange={(e) => {
                                    const newStart = e.target.value;

                                    if (filters.endDate && new Date(newStart) > new Date(filters.endDate)) {
                                        toast.error("Start Date cannot be greater than End Date");
                                        return;
                                    }

                                    setFilters({
                                        ...filters,
                                        startDate: newStart,
                                        dateRangePreset: "",
                                    });
                                }}
                            />

                            <input
                                type="date"
                                className="form-control"
                                value={filters.endDate}
                                onChange={(e) => {
                                    const newEnd = e.target.value;

                                    if (filters.startDate && new Date(newEnd) < new Date(filters.startDate)) {
                                        toast.error("End Date cannot be earlier than Start Date");
                                        return;
                                    }

                                    setFilters({
                                        ...filters,
                                        endDate: newEnd,
                                        dateRangePreset: "",
                                    });
                                }}
                            />
                        </div>

                    </div>
                </div>

                {/* ✅ Table */}
                <div className="table-responsive">
                    <table className="table  align-middle">
                        <thead className="table-primary text-start">
                            <tr>
                                <th style={{ backgroundColor: "#DFE4EB" }}>Employee Name</th>
                                <th onClick={() => handleSort("leaveType")} style={{ backgroundColor: "#DFE4EB", cursor: "pointer" }}>
                                    Leave Type
                                </th>
                                <th onClick={() => handleSort("startDate")} style={{ backgroundColor: "#DFE4EB", cursor: "pointer" }}>
                                    Dates
                                </th>
                                <th style={{ backgroundColor: "#DFE4EB" }}>Leave Reason</th>
                                <th onClick={() => handleSort("status")} style={{ backgroundColor: "#DFE4EB", cursor: "pointer" }}>
                                    Status
                                </th>
                                <th style={{ backgroundColor: "#DFE4EB" }}> Reason</th>
                                <th className="text-start" style={{ backgroundColor: "#DFE4EB" }}>Approve | Reject | Forward</th>
                            </tr>
                        </thead>
                        <tbody>
                            {filteredLeaves.length === 0 ? (
                                <tr>
                                    <td colSpan="7" className="text-center text-muted">
                                        No leave requests found.
                                    </td>
                                </tr>
                            ) : (
                                filteredLeaves.map((leave) => (
                                    <tr key={leave.id}>
                                        <td>{leave.employeeName || "—"}</td>
                                        <td>{leave.leaveType}</td>
                                        <td>{formatDate(leave.startDate)} - {formatDate(leave.endDate)}</td>
                                        <td title={leave.reason || ""}>
                                            {truncate(leave.reason, 30) || "—"}
                                        </td>

                                        <td>{leave.status}</td>
                                        <td title={leave.actionReason || leave.cancelReason || ""}>
                                            {truncate(
                                                leave.actionReason || leave.cancelReason,
                                                30
                                            ) || "Not Provided"}
                                        </td>

                                        <td>
                                            {leave.status === "PENDING" && (
                                                <>
                                                    <span
                                                        className="text-primary me-3 fw-semibold"
                                                        style={{ cursor: "pointer", textDecoration: "none" }}
                                                        onClick={() => handleLeaveStatus(leave.id, "APPROVED")}
                                                    >
                                                        Approve
                                                    </span>
                                                    <span
                                                        className="text-primary me-3 fw-semibold"
                                                        style={{ cursor: "pointer", textDecoration: "none" }}
                                                        onClick={() => handleRejectClick(leave.id)}
                                                    >
                                                        Reject
                                                    </span>
                                                    <span
                                                        className="text-primary fw-semibold"
                                                        style={{ cursor: "pointer", textDecoration: "none" }}
                                                        onClick={() => {
                                                            setSelectedLeaveId(leave.id);
                                                            setRejectReason("");
                                                            setForwardTo("");
                                                            setActionType("FORWARDED");
                                                            setShowRejectPopup(true);
                                                        }}
                                                    >
                                                        Forward
                                                    </span>

                                                </>
                                            )}
                                        </td>
                                    </tr>
                                ))
                            )}
                        </tbody>
                    </table>
                </div>

                <div className="mt-4">
                    <h4>Upcoming Approved Leaves (Next 7 Days)</h4>
                    <table className="table ">
                        <thead className="table-primary">
                            <tr>
                                <th style={{ backgroundColor: "#DFE4EB" }}>Employee Name</th>
                                <th style={{ backgroundColor: "#DFE4EB" }}>Leave Type</th>
                                <th style={{ backgroundColor: "#DFE4EB" }}>Dates</th>
                            </tr>
                        </thead>
                        <tbody>
                            {getUpcomingLeaves().length === 0 ? (
                                <tr>
                                    <td colSpan="3" className="text-center text-muted">
                                        No approved leaves in the next 7 days.
                                    </td>
                                </tr>
                            ) : (
                                getUpcomingLeaves().map((leave) => (
                                    <tr key={leave.id}>
                                        <td>{leave.employeeName || "—"}</td>
                                        <td>{leave.leaveType}</td>
                                        <td>{formatDate(leave.startDate)} - {formatDate(leave.endDate)}</td>
                                    </tr>
                                ))
                            )}
                        </tbody>
                    </table>
                </div>


                {/* ✅ Reject Modal */}
                {showRejectPopup && (
                    <div className="modal fade show d-block" style={{ backgroundColor: "rgba(0,0,0,0.5)" }}>
                        <div className="modal-dialog modal-dialog-centered">
                            <div className="modal-content p-3">
                                <div className="modal-header" style={{ backgroundColor: "#607799", color: "#fffcfcff" }}>
                                    <h5 className="modal-title">
                                        {actionType === "REJECTED" ? "Reject Leave" : "Forward Leave"}
                                    </h5>
                                    <button type="button" className="btn-close" onClick={() => setShowRejectPopup(false)}></button>
                                </div>
                                <div className="modal-body">
                                    {actionType === "FORWARDED" && (
                                        <div className="mb-3">
                                            <label className="form-label fw-semibold">Forward To</label>
                                            <select
                                                className="form-select"
                                                value={forwardTo}
                                                onChange={(e) => setForwardTo(e.target.value)}
                                            >
                                                <option value="">Select</option>

                                                {getForwardOptions().map((opt, idx) => (
                                                    <option key={idx} value={opt.value}>
                                                        {opt.label}
                                                    </option>
                                                ))}
                                            </select>



                                        </div>
                                    )}

                                    <textarea
                                        className="form-control"
                                        rows="3"
                                        placeholder={
                                            actionType === "REJECTED"
                                                ? "Enter reason for rejection"
                                                : "Enter reason for forwarding"
                                        }
                                        value={rejectReason}
                                        onChange={(e) => setRejectReason(e.target.value)}
                                        required
                                    />
                                </div>

                                <div className="modal-footer">
                                    <button className="btn btn-primary" onClick={handleConfirmAction}>
                                        Confirm
                                    </button>

                                    <button className="btn btn-secondary" onClick={() => setShowRejectPopup(false)}>Cancel</button>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </>
    );
}
